const EMAIL_TEMPLATES = {
    modelActivation: "model_activation",
    enrModification: "enr_modification"
};

const settings = {
    EMAIL_TEMPLATES
}

export default settings;

